import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
var css = {
  "progressBar": "rui-KWfbV",
  "step": "rui-gZd63",
  "disabled": "rui-LaRoo"
};
var colors = {
  "fill-primaryBase": "rui-jB92v",
  "color-primaryBase": "rui-wdkgt",
  "background-primaryBase": "rui-LmOU7",
  "fill-primaryLight1": "rui-GfHzu",
  "color-primaryLight1": "rui-iq88W",
  "background-primaryLight1": "rui-rjE6y",
  "fill-primaryLight2": "rui-3NgQ0",
  "color-primaryLight2": "rui-oV74W",
  "background-primaryLight2": "rui-IvN2P",
  "fill-blueBase": "rui-cvER7",
  "color-blueBase": "rui-UDquW",
  "background-blueBase": "rui-EPZTB",
  "fill-blueLight1": "rui-o76c2",
  "color-blueLight1": "rui-MBMsh",
  "background-blueLight1": "rui-N1Hst",
  "fill-blueLight2": "rui-ENCiE",
  "color-blueLight2": "rui-lRwOJ",
  "background-blueLight2": "rui-Da2Lo",
  "fill-blueLight3": "rui-3odHA",
  "color-blueLight3": "rui-X1r7O",
  "background-blueLight3": "rui-oy9LB",
  "fill-blueLight4": "rui-igOU4",
  "color-blueLight4": "rui-0ZAG2",
  "background-blueLight4": "rui-kqV74",
  "fill-blueDark1": "rui-u9LSc",
  "color-blueDark1": "rui-OWQMo",
  "background-blueDark1": "rui-mN2OB",
  "fill-blueDark2": "rui-0fHXM",
  "color-blueDark2": "rui-04cAb",
  "background-blueDark2": "rui-hSPCn",
  "fill-accentBase": "rui-GMoms",
  "color-accentBase": "rui-fo0ob",
  "background-accentBase": "rui-0VmGD",
  "fill-accentLight1": "rui-F89wb",
  "color-accentLight1": "rui-mfVel",
  "background-accentLight1": "rui-DtWCf",
  "fill-accentLight2": "rui-vgw7W",
  "color-accentLight2": "rui-Touqo",
  "background-accentLight2": "rui-sl94N",
  "fill-accentLight3": "rui-IWWIJ",
  "color-accentLight3": "rui-gYDaG",
  "background-accentLight3": "rui-fiqak",
  "fill-accentLight4": "rui-mjmul",
  "color-accentLight4": "rui-vMKtu",
  "background-accentLight4": "rui-x0RH1",
  "fill-accentDark1": "rui-iMJQy",
  "color-accentDark1": "rui-IIodT",
  "background-accentDark1": "rui-ksfTA",
  "fill-accentDark2": "rui-1OqHH",
  "color-accentDark2": "rui-Oawcs",
  "background-accentDark2": "rui-AzaqW",
  "fill-redBase": "rui-mMyxL",
  "color-redBase": "rui-BEROn",
  "background-redBase": "rui-JnrHG",
  "fill-redLight1": "rui-IadSl",
  "color-redLight1": "rui-Fp6ht",
  "background-redLight1": "rui-kR1Be",
  "fill-redLight2": "rui-Bzy81",
  "color-redLight2": "rui-qyZ2Q",
  "background-redLight2": "rui-q5bTV",
  "fill-redLight3": "rui-kn0ag",
  "color-redLight3": "rui-HBfNw",
  "background-redLight3": "rui-c3q3z",
  "fill-redLight4": "rui-aoq90",
  "color-redLight4": "rui-Px4Fz",
  "background-redLight4": "rui-DIskB",
  "fill-redDark1": "rui-PSRh8",
  "color-redDark1": "rui-FhuBr",
  "background-redDark1": "rui-WuCJf",
  "fill-redDark2": "rui-ixSO9",
  "color-redDark2": "rui-0OOyi",
  "background-redDark2": "rui-T4y7T",
  "fill-redDark3": "rui-JTU2M",
  "color-redDark3": "rui-jRZo8",
  "background-redDark3": "rui-QLIHa",
  "fill-monetizationBase": "rui-Eydig",
  "color-monetizationBase": "rui-uTYv9",
  "background-monetizationBase": "rui-N8qC8",
  "fill-monetizationLight1": "rui-Xxpie",
  "color-monetizationLight1": "rui-P12qs",
  "background-monetizationLight1": "rui-1YHTn",
  "fill-monetizationLight2": "rui-iBucs",
  "color-monetizationLight2": "rui-StbV5",
  "background-monetizationLight2": "rui-wSoFk",
  "fill-monetizationLight3": "rui-abSrD",
  "color-monetizationLight3": "rui-3AXj0",
  "background-monetizationLight3": "rui-Sknm9",
  "fill-monetizationLight4": "rui-j3JzW",
  "color-monetizationLight4": "rui-13wXX",
  "background-monetizationLight4": "rui-oKoUe",
  "fill-monetizationDark1": "rui-MZaDS",
  "color-monetizationDark1": "rui-UmfDC",
  "background-monetizationDark1": "rui-EkzQA",
  "fill-monetizationDark2": "rui-ipobz",
  "color-monetizationDark2": "rui-JPGx6",
  "background-monetizationDark2": "rui-xIIkW",
  "fill-primary": "rui-lquEm",
  "color-primary": "rui-cpAKV",
  "background-primary": "rui-XXowP",
  "fill-primaryDark": "rui-PTeN7",
  "color-primaryDark": "rui-gVs4X",
  "background-primaryDark": "rui-T9oOd",
  "fill-primaryLight": "rui-J6QSl",
  "color-primaryLight": "rui-T7vf7",
  "background-primaryLight": "rui-vQIks",
  "fill-accent": "rui-xJ5b2",
  "color-accent": "rui-ZElCp",
  "background-accent": "rui-uQvDc",
  "fill-accentDark": "rui-YQRFW",
  "color-accentDark": "rui-9qgFU",
  "background-accentDark": "rui-020qz",
  "fill-accentLight": "rui-ooZSa",
  "color-accentLight": "rui-3hYFm",
  "background-accentLight": "rui-xGHY8",
  "fill-black": "rui-jxF7i",
  "color-black": "rui-PJX77",
  "background-black": "rui-J9Qyw",
  "fill-blackGradients": "rui-Qm6iF",
  "color-blackGradients": "rui-5opXR",
  "background-blackGradients": "rui-tVZlj",
  "fill-blackBackground": "rui-v8UiL",
  "color-blackBackground": "rui-byiN2",
  "background-blackBackground": "rui-SKRsl",
  "fill-blackDividers": "rui-PiShh",
  "color-blackDividers": "rui-3fj4U",
  "background-blackDividers": "rui-DQf9w",
  "fill-blackDisabled": "rui-WYqQq",
  "color-blackDisabled": "rui-7qyou",
  "background-blackDisabled": "rui-3DpW2",
  "fill-blackHintText": "rui-O9Coz",
  "color-blackHintText": "rui-g4psg",
  "background-blackHintText": "rui-LyUuo",
  "fill-blackSecondaryText": "rui-UJ1uk",
  "color-blackSecondaryText": "rui-M9Hsu",
  "background-blackSecondaryText": "rui-tbXQf",
  "fill-blackIcons": "rui-momFz",
  "color-blackIcons": "rui-LeYwy",
  "background-blackIcons": "rui-oe6Rn",
  "fill-blackText": "rui-w4DG7",
  "fill-primaryLight3": "rui-fFVXq",
  "color-blackText": "rui-zMy84",
  "background-blackText": "rui-PG7vx",
  "fill-white": "rui-7jwXk",
  "color-white": "rui-MhY7M",
  "background-white": "rui-6COo7",
  "fill-whiteGradients": "rui-mwKJ8",
  "color-whiteGradients": "rui-6bo9q",
  "background-whiteGradients": "rui-6ozAz",
  "fill-whiteDividers": "rui-od7VY",
  "color-whiteDividers": "rui-J8L5Q",
  "background-whiteDividers": "rui-gdoSY",
  "fill-whiteDisabled": "rui-vr7Os",
  "color-whiteDisabled": "rui-LEQ9k",
  "background-whiteDisabled": "rui-EZiXI",
  "fill-whiteHintText": "rui-F7XqR",
  "color-whiteHintText": "rui-bCkTu",
  "background-whiteHintText": "rui-EzCEh",
  "fill-whiteSecondaryText": "rui-cu7c6",
  "color-whiteSecondaryText": "rui-z6iZj",
  "background-whiteSecondaryText": "rui-7SZxL",
  "fill-whiteIcons": "rui-o3KKi",
  "color-whiteIcons": "rui-mc0NL",
  "background-whiteIcons": "rui-k2uh2",
  "fill-whiteText": "rui-XodnO",
  "color-whiteText": "rui-4eJeU",
  "background-whiteText": "rui-vcqKm",
  "fill-background": "rui-pbbpn",
  "color-background": "rui-Jgjio",
  "background-background": "rui-HdFHP",
  "fill-greyBorder": "rui-EWhNX",
  "color-greyBorder": "rui-jylYc",
  "background-greyBorder": "rui-c2Ank",
  "fill-lightGrey": "rui-4DnkW",
  "color-lightGrey": "rui-yGODy",
  "background-lightGrey": "rui-FZFlR",
  "fill-blackDividers2": "rui-yGBou",
  "color-blackDividers2": "rui-Mlvzl",
  "background-blackDividers2": "rui-YZYxQ",
  "fill-background2": "rui-lb2gY",
  "color-background2": "rui-rp7Xv",
  "background-background2": "rui-Dw7Er",
  "fill-blackBackground2": "rui-nVNs4",
  "color-blackBackground2": "rui-bDf7u",
  "background-blackBackground2": "rui-3bqKs",
  "fill-error": "rui-8kcgO",
  "color-error": "rui-cksy7",
  "background-error": "rui-USIn8",
  "fill-errorDark": "rui-Qx1X8",
  "color-errorDark": "rui-9Rlhy",
  "background-errorDark": "rui-oAZqG",
  "fill-errorLight": "rui-YiNUc",
  "color-errorLight": "rui-dKNop",
  "background-errorLight": "rui-8cunC",
  "fill-facebook": "rui-v51zl",
  "color-facebook": "rui-FUN52",
  "background-facebook": "rui-BntSw",
  "fill-messenger": "rui-SOzsO",
  "color-messenger": "rui-m58uo",
  "background-messenger": "rui-Har5m",
  "fill-whatsapp": "rui-sJo5r",
  "color-whatsapp": "rui-9YHJp",
  "background-whatsapp": "rui-PwV8e",
  "fill-google": "rui-pSacl",
  "color-google": "rui-nqkos",
  "background-google": "rui-WB8ZX",
  "fill-monetization": "rui-iBRfx",
  "color-monetization": "rui-3OFdk",
  "background-monetization": "rui-oclzc",
  "fill-monetizationDark": "rui-PhjOh",
  "color-monetizationDark": "rui-kRToN",
  "background-monetizationDark": "rui-YdBVJ",
  "fill-monetizationLight": "rui-tMocb",
  "color-monetizationLight": "rui-VkVat",
  "background-monetizationLight": "rui-0yPcs",
  "fill-infoBadge": "rui-mSROW",
  "color-infoBadge": "rui-1BzfV",
  "background-infoBadge": "rui-WT3wD",
  "fill-promotedBadge": "rui-32eH7",
  "color-promotedBadge": "rui-qBsOW",
  "background-promotedBadge": "rui-3OQa4",
  "fill-chatPrimary": "rui-ELgUj",
  "color-chatPrimary": "rui-2Usf0",
  "background-chatPrimary": "rui-HlRNh",
  "fill-chatSecondary": "rui-8GOef",
  "color-chatSecondary": "rui-z0JEf",
  "background-chatSecondary": "rui-tFzld",
  "fill-disabled": "rui-brZoK",
  "color-disabled": "rui-oNwMq",
  "background-disabled": "rui-OoSei",
  "fill-disabledText": "rui-i1ika",
  "color-disabledText": "rui-oHrQe",
  "background-disabledText": "rui-o0fow",
  "fill-label": "rui-miRYI",
  "color-label": "rui-7cNYe",
  "background-label": "rui-EVk9P"
};
var ProgressBar = function ProgressBar(_ref) {
  var _ref$total = _ref.total,
    total = _ref$total === void 0 ? 10 : _ref$total,
    _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? 0 : _ref$fill,
    _ref$fillColor = _ref.fillColor,
    fillColor = _ref$fillColor === void 0 ? 'monetization' : _ref$fillColor;
  var steps = [];
  for (var i = 1; i <= total; i++) {
    var _classNames;
    steps.push( /*#__PURE__*/React.createElement("div", {
      "data-aut-id": "step",
      className: classNames(css.step, (_classNames = {}, _defineProperty(_classNames, colors["background-".concat(fillColor)], i <= fill), _defineProperty(_classNames, css.disabled, i > fill), _classNames)),
      key: i
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: css.progressBar,
    "data-aut-id": "progressBar"
  }, steps);
};
export default ProgressBar;